import moment from "moment";
import { useEffect, useState } from "react";
import { useLocation, useNavigate } from "react-router-dom";
import { getAppointmentWithDetails } from "../services/Appointment";


export const BookingConfirmation = () => {
    const navigate = useNavigate();
    const location = useLocation();
    const { id, serviceType } = location.state || {};
    const [data, setData] = useState<any>({});
    const [dataLoaded, setDataLoaded] = useState<boolean>(false);

    useEffect(() => {
        if (id) {
            setDataLoaded(false);
            getAppointmentWithDetails(id)
                .then((data) => {
                    setData(data);
                    setDataLoaded(true);
                })
                .catch((error) => {
                    console.error((error))
                })
        }
        else {
            navigate("/");
        }
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [id])

    return (
        <div className="w-full bg-gray-100 py-10 flex flex-col items-center">
            {
                !dataLoaded && (
                    <div className="flex justify-center items-center py-4 h-screen">
                        <div className="animate-spin h-8 w-8 border-2 border-primary border-t-transparent rounded-full mx-auto" />
                    </div>
                )
            }

            {
                (dataLoaded && data) && (
                    <>
                        <div className="flex justify-center items-center">
                            <img src="/images/success-removebg-preview.png" alt="success" className="h-[120px]" />
                        </div>

                        <div className=" max-w-2xl w-full bg-white border rounded-md p-6 space-y-4 flex flex-col items-center">
                            <div className="w-full text-center space-y-4 border-b py-2">
                                <span className="text-lg font-semibold inline-block">Thanks for booking with us</span><br />
                                <span className="text-sm font-medium text-gray-500 inline-block">The service confirmation for <span className="text-primary">{data?.service?.serviceName}</span> has been sent to {data?.customer?.email}. If you don't see the email, be sure to check your spam and junk mail folders.</span>
                            </div>

                            <div className="text-start space-y-3 border-b py-2 w-full">
                                <span className="text-sm font-semibold">Service Number</span><br />
                                <span className="text-sm font-medium text-gray-500">{data?.service?.serviceNumber}</span>
                            </div>
                            {
                                (data?.vehicle && (data?.vehicle?.year > 0 && data?.vehicle?.make && data?.vehicle?.model)) && (
                                    <div className="w-full text-start space-y-3 border-b py-2">
                                        <span className="text-sm font-semibold">Vehicle Details</span><br />
                                        <span className="text-sm font-medium text-gray-500">{data?.vehicle?.year} {data?.vehicle?.make} {data?.vehicle?.model}</span>
                                    </div>
                                )
                            }

                            {
                                data?.vehicleTrim && (
                                    <div className="w-full text-start space-y-3 border-b py-2">
                                        <span className="text-sm font-semibold">Trim</span><br />
                                        <span className="text-sm font-medium text-gray-500">{data?.vehicleTrim?.trimName}</span>
                                    </div>
                                )
                            }

                            {
                                (data?.tireFitment && !data?.rearTireFitment && !data?.customerRequestedTireSize) && (
                                    <div className="w-full text-start space-y-3 border-b py-2">
                                        <span className="text-sm font-semibold">Tire Details</span><br />
                                        <span className="text-sm font-medium text-gray-500">{data?.tireFitment?.metricWidth}/ {data?.tireFitment?.aspectRatio} R{data?.tireFitment?.diameter}</span>
                                    </div>
                                )
                            }



                            {
                                (data?.tireCount > 0) && (
                                    <div className="w-full text-start space-y-3 border-b py-2">
                                        <span className="text-sm font-semibold">{serviceType} Count</span><br />
                                        <span className="text-sm font-medium text-gray-500">{data?.tireCount}</span>
                                    </div>
                                )
                            }


                            {
                                (data?.tireFitment && data?.rearTireFitment && !data?.customerRequestedTireSize) && (
                                    <>
                                        <div className="w-full text-start space-y-3 border-b py-2">
                                            <span className="text-sm font-semibold">Front Tire Details</span><br />
                                            <span className="text-sm font-medium text-gray-500">{data?.tireFitment?.metricWidth}/ {data?.tireFitment?.aspectRatio} R{data?.tireFitment?.diameter}</span>
                                        </div>

                                        <div className="w-full text-start space-y-3 border-b py-2">
                                            <span className="text-sm font-semibold">Rear Tire Details</span><br />
                                            <span className="text-sm font-medium text-gray-500">{data?.rearTireFitment?.metricWidth}/ {data?.rearTireFitment?.aspectRatio} R{data?.rearTireFitment?.diameter}</span>
                                        </div>
                                    </>

                                )
                            }

                            {
                                (!data?.tireFitment && data?.rearTireFitment && !data?.customerRequestedTireSize) && (
                                    <>
                                        <div className="w-full text-start space-y-3 border-b py-2">
                                            <span className="text-sm font-semibold">Rear Tire Details</span><br />
                                            <span className="text-sm font-medium text-gray-500">{data?.rearTireFitment?.metricWidth}/ {data?.rearTireFitment?.aspectRatio} R{data?.rearTireFitment?.diameter}</span>
                                        </div>
                                    </>

                                )
                            }




                            {
                                (data?.customerRequestedTireSize) && (
                                    <div className="w-full text-start space-y-3 border-b py-2">
                                        <span className="text-sm font-semibold">Requested Tire Details</span><br />
                                        <span className="text-sm font-medium text-gray-500">{data?.customerRequestedTireSize?.metricWidth}/ {data?.customerRequestedTireSize?.aspectRatio} R{data?.customerRequestedTireSize?.diameter}</span>
                                    </div>
                                )
                            }



                            <div className="w-full text-start space-y-3 border-b py-2">
                                <span className="text-sm font-semibold">Service Date</span><br />
                                <span className="text-sm font-medium text-gray-500">{moment(data?.appointmentDate?.split("T")[0]).format("dddd, MMM DD, YYYY")}</span>
                            </div>

                            <div className="w-full text-start space-y-3 border-b py-2">
                                <span className="text-sm font-semibold">Service Time</span><br />
                                <span className="text-sm font-medium text-gray-500">{moment(data?.timeSlot, "HH:mm").format("hh:mm A")}</span>
                            </div>

                            <div className="w-full text-start space-y-3 border-b py-2">
                                <span className="text-sm font-semibold">Service Location</span><br />
                                <span className="text-sm font-medium text-gray-500">{data?.location?.street} {data?.location?.city} {data?.location?.state} {data?.location?.zipCode}</span>
                            </div>


                            <button className="bg-primary hover:bg-orange-600 text-white text-sm py-3 px-8 rounded-[70px] font-medium transition" onClick={() => (navigate("/"))}>
                                Go to homepage
                            </button>
                        </div>
                    </>
                )
            }

        </div>
    )
}